import api from '@/services/api'
import dayjs from 'dayjs'

export default {
  namespaced: true,
  state: {
    weekdays: [],
    options: {
      initialView: 'dayGridMonth',
      fixedWeekCount: false,
      contentHeight: 'auto',
      showNonCurrentDates: false,
      eventDisplay: 'block',
      timeZone: '',
      events: [],
      views: {
        dayGrid: {
          dayMaxEventRows: 2
        }
      }
    },
    httpError: {
      status: '',
      message: 'Oof. Server went bonkers. You can try again.'
    },
    eventSelectedDetails: {}
  },

  mutations: {
    setWeekdays(state) {
      state.weekdays = dayjs.weekdays()
    },
    setEvents(state, events) {
      state.options.events = events
    },
    setTimezone(state, tz) {
      state.options.timeZone = tz
    },
    setHttpError(state, err) {
      state.httpError.status = err.status
    },
    setEventSelectedDetails(state, event) {
      state.eventSelectedDetails = event
    },
    clearEventSelectedDetails(state, event) {
      state.eventSelectedDetails = {}
    }
  },

  actions: {
    async setEventTimezone({ state }, event) {
      if (event.startRecur && event.extendedProps.repeat_by !== 'daily') {
        event.startRecur = dayjs(event.startRecur)
          .tz(state.options.timeZone)
          .format()
        event.endRecur = dayjs(event.endRecur)
          .tz(state.options.timeZone)
          .format()
        event.isRecurring = true

        event.repeats = []
        event.daysOfWeek.sort((a, b) => a - b)
        event.daysOfWeek.forEach(day => {
          event.repeats.push(state.weekdays[day])
        })
      } else if (
        event.startRecur &&
        event.extendedProps.repeat_by === 'daily'
      ) {
        event.start = dayjs(event.startRecur)
          .tz(state.options.timeZone)
          .format()
        event.end = dayjs(event.endRecur)
          .tz(state.options.timeZone)
          .format()

        event.isRecurring = true
        event.extendedProps.days_of_week = event.daysOfWeek
        delete event.startRecur
        delete event.endRecur
        delete event.daysOfWeek
      } else {
        event.isRecurring = false
        event.start = dayjs(event.start)
          .tz(state.options.timeZone)
          .format()
      }
      return event
    },
    async setRecurringEvents({ dispatch, commit }, events) {
      commit('setWeekdays')

      if (events.length > 1) {
        events.forEach(async event => {
          event.color = '#00adcd'

          event = await dispatch('setEventTimezone', event)
        })
      } else {
        events = await dispatch('setEventTimezone', events)
      }
      return events
    },
    async getEvents({ commit, dispatch }, params) {
      return new Promise(resolve => {
        api.get(`events`, { params }).then(async ({ data }) => {
          let eventsData = await dispatch('setRecurringEvents', data.data)
          await commit('setEvents', eventsData)
          resolve()
        })
      })
    },
    async getEvent({ commit, dispatch }, eventId) {
      return new Promise(resolve => {
        api.get(`events/${eventId}`).then(async ({ data }) => {
          let eventData = await dispatch('setRecurringEvents', data.data)
          await commit('setEventSelectedDetails', eventData)
          resolve()
        })
      })
    },
    // eslint-disable-next-line
    async updateEvent({ }, event) {
      return new Promise(resolve => {
        api.put(`events/${event.id}`, event).then(() => {
          resolve()
        })
      })
    },
    async postEvent({ commit }, event) {
      return new Promise((resolve, reject) => {
        api
          .post(`events`, event)
          .then(() => {
            resolve()
          })
          .catch(errors => {
            if (errors.data && errors.data.errors) {
              reject(errors.data.errors)
            } else if (errors.response) {
              commit('setHttpError', errors.response)
              reject(errors.response)
            }
          })
      })
    },
    async deleteEvent({ commit }, eventId) {
      return new Promise((resolve, reject) => {
        api
          .delete(`events/${eventId}`)
          .then(() => {
            resolve()
          })
          .catch(errors => {
            if (errors.data && errors.data.errors) {
              reject(errors.data.errors)
            } else if (errors.response) {
              commit('setHttpError', errors.response)
              reject(errors.response)
            }
          })
      })
    }
  }
}
